import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { useParams } from 'react-router';
import VizsgaFeladatEditService from '../service/VizsgaFeladatEditService';

const config = data => {
	return {
		key: 'vizsgaFeladatEditForm',
		text: 'Feladat',
		textKey: 'vizsgaFeladatEditForm',
		title: item => (item !== null ? `${item.kod} - ${item.kerdesSorszam}.${item.kerdesAlsorszam}.${item.kerdesSubsorszam}` : null),
		service: VizsgaFeladatEditService,
		fields: [
			{
				key: 'kerdesLeiras',
				text: 'Kérdés leírás',
				textKey: 'kerdesLeiras',
				component: EditFormTextField,
				multiline: true,
				readOnly: true
			},
			{
				key: 'kod',
				text: 'Kód',
				textKey: 'kod',
				component: EditFormTextField,
				readOnly: true
			},
			{
				key: 'kerdesSorszam',
				text: 'Kérdés sorszám',
				textKey: 'kerdesSorszam',
				component: EditFormTextField,
				readOnly: true
			},
			{
				key: 'kerdesAlsorszam',
				text: 'Kérdés alsorszám',
				textKey: 'kerdesAlsorszam',
				component: EditFormTextField,
				readOnly: true
			},
			{
				key: 'kerdesSubsorszam',
				text: 'Kérdés subsorszám',
				textKey: 'kerdesSubsorszam',
				component: EditFormTextField,
				readOnly: true
			},
			{
				key: 'torolt',
				text: 'Törölt',
				textKey: 'torolt',
				component: EditFormSelectField,
				items: [
					{
						id: 1,
						name: 'Igen'
					},
					{
						id: 0,
						name: 'Nem'
					}
				]
			}
		]
	};
};

function VizsgaFeladatEditFrom() {
	const { vizsgafeladatsor } = useParams();
	const myConfig = config();
	return <EditFormPage config={myConfig} />;
}

export default VizsgaFeladatEditFrom;
